import React, {useReducer} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";

import {updateCanvasCount} from "../../../../../actions/actionFunctions";
// import {SIDE_POSITIONS} from "../../../core/constants";
import WithClickCount from "../../../hocs/withClickCount";
import {navFeatureCLick} from "../../../lookNavigation/lookFunctions";
import {featureInterface} from "../../../../../interfaces/featureInterface";
// import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";

const positionsArray = ["single", "double"];

const GroheFeatureOptionsCabinetSide = (props) => {

  const {lookActiveFeature, updateCanvasCount, parentOptionClick} = props;
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const featureGroup = lookActiveFeature.getParent();

  // if (!featureGroup.layerPositions || (Object.keys(featureGroup.layerPositions).length !== SIDE_POSITIONS.length)) {
  //   return null
  // }

  const currentMeta = lookActiveFeature.metaData.layerPosition;
  const neededPosition = currentMeta === "L" || currentMeta === "R" ? "C" : "R"; // R is just to check
  const sameFeature = featureGroup.getMatchingPositionFeature(neededPosition, lookActiveFeature);
  if (!sameFeature) {
    return null
  }

  const optionsButtonClick = (position, maxClickCountReached) => {
    // const featureLabel = (Analytics.getStringForAnalytics(getValueText(option.metaValue))).toLowerCase() + "_" + Analytics.getSkuForAnalytics(lookActiveFeature);
    // const analyticsLabel = IS_PRODUCT_JOURNEY
    //   ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureOptions + featureLabel
    //   : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureOptions + featureLabel;
    // Analytics.sendClickEvent(analyticsLabel);

    if (maxClickCountReached()) { // fabricator settings click lead capture
      return false;
    }

    const positionLetter = position === "single" ? "C" : "R";
    const sameFeature = featureGroup.getMatchingPositionFeature(positionLetter, lookActiveFeature);
    if (sameFeature) {
      if (parentOptionClick) {
        parentOptionClick(sameFeature)
      }
      navFeatureCLick(sameFeature, true, true)
    }

    updateCanvasCount();
    forceUpdate();
  };

  const isButtonDisabled = (isActive, position) => {
    if (isActive) {
      return false
    }
    const neededPosition = position === "single" ? "C" : "R"; // R is just to check
    let disabled = !featureGroup.getMatchingPositionFeature(neededPosition, lookActiveFeature);
    // if (!disabled && Object.keys(VANITY_TYPES).every(type => featureGroup.partId !== type)) {
    //   const vanityParent = featureGroup.getParent();
    //   if (vanityParent && vanityParent.vanity_type) {
    //     const currentActiveVanType = vanityParent.relatedItems.find(relItem => relItem.partId === vanityParent.vanity_type);
    //     if (currentActiveVanType) {
    //       disabled = !currentActiveVanType.getMatchingPositionFeature(position, currentActiveVanType.activeFeature)
    //     }
    //   }
    // }
    return disabled
  }

  return (
    <WithClickCount>
      {(maxClickCountReached) => (
        <div className="lk-feature__options">
          <span className="lk-feature__options-title">
            <FormattedMessage id="grohe.feature.placement"/>:
          </span>
          <div className="lk-feature__options-list">
            {positionsArray.map(position => {
              const isActive = position === "single"
                ? !!featureGroup.layerPositions["C"]
                : featureGroup.layerPositions["L"] || featureGroup.layerPositions["R"];
              const disabled = isButtonDisabled(isActive, position);
              return (
                <Button className={"look-button look-button--half-radius look-button--option lk-type"
                  + (isActive ? " look-button--option-active" : "") + (disabled ? " look-button--disabled" : "")}
                        key={position}
                        disabled={disabled}
                        onClick={() => optionsButtonClick(position, maxClickCountReached)}>
                  <FormattedMessage id={"grohe.feature.placement." + position}/>
                </Button>
              )
            })}
          </div>
        </div>
      )}
    </WithClickCount>
  )
};

GroheFeatureOptionsCabinetSide.propTypes = {
  metaName: PropTypes.string,
  parentOptionClick: PropTypes.func,
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store, ownProps) => {
  const {lookActiveFeature, featureGroupCount} = store.lookState;
  const {canvasCount} = store.bathroomVisualizerState;

  return {
    lookActiveFeature: ownProps.activeFeature || lookActiveFeature,
    canvasCount,
    featureGroupCount, // to update options after all features received
  };
};

const mapDispatchToProps = {
  updateCanvasCount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatureOptionsCabinetSide)
)
